import AddChapterModalContainer from './AddChapterModalContainer';

export default AddChapterModalContainer;
